import React from "react";
import PropTypes from "prop-types";
import { i18next } from "@translations/i18next";
import { withState } from "react-searchkit";

const CountElement = ({ totalResults }) => {
  return (
    <label className="grey">
      {i18next.t("Results")}: <span className="text-big">{totalResults}</span>
    </label>
  );
};

const ResultCount = ({ currentResultsState = {} }) => {
  const total = currentResultsState?.data?.total;
  const { loading } = currentResultsState;
  // determine if we are in searchApp context or pure searchkit
  const resultsLoaded = !loading && total > 0;

  return resultsLoaded && <CountElement totalResults={total} />;
};

CountElement.propTypes = {
  totalResults: PropTypes.number.isRequired,
};

ResultCount.propTypes = {
  currentResultsState: PropTypes.object,
};

export const ResultCountWithState = withState(ResultCount);
